import styled from 'styled-components';
import { appConfig } from '../../configureApp';

const TrawickTD = styled.td`
  padding: 0.75rem;
  vertical-align: top;
  border: 1px solid #e9ecef;
`;

const SCTITD = styled.td`
    padding: 10px;
    font-family: 'Omnes';
    font-size: 16px;
    font-weight: 500;
    color: #4A4A4A;
    border: 1px solid #D1D1D1;
`;

const TD = appConfig.reactAppEnv === 'scti' || appConfig.reactAppEnv === 'tugo' ? SCTITD : TrawickTD;

export default TD;



// WEBPACK FOOTER //
// ./app/components/Table/TD.js